import * as React from "react";
import { Button } from "@grandvisionhq/elements";
/* empty css                */
const CardButton = ({ "data-t": dataT, onClick, children, ...rest }) => {
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      "data-t": dataT || "card-button",
      className: "card-button",
      onClick,
      variant: "ghost",
      ...rest
    },
    children
  );
};
export {
  CardButton as default
};
//# sourceMappingURL=CardButton.js.map
